
import { Component, Mixins } from 'vue-property-decorator';
import { PageQuery } from '@/mixins/page_query';
import { toast } from '../../../utils/common';
import { iSelectGame, iGameModel } from '@/interface/game-manage';
import { getGameManage, delGame, UpdateGame, goRefreshCache } from '@/api/game-manage';
import GameCreate from './game-create.vue';
import { iUploadeImagesList } from '@/interface/imageUpload';

const defaultModal: iGameModel = {
  id: 0 /* 新增为0， 编辑时ID来源于接口 > 0 */,
  name: '',
  category_name: '',
  category_id: -1,
  account_num: 0,
  remark: '',
  gid: '',
  path: '',
  act_free: 1,
  file_id: -1,
  main_img: '',
  game_media: [],
  account_mode: 2,
  steam_gid: '',
  archive_path: '',
  times_limit: 0,
  process_name: '',
  process_watch_min: 3,
  conn_tips: '',
};

@Component({
  components: { GameCreate },
})
export default class GameManage extends Mixins(PageQuery) {
  private visibleDialog: boolean = false;
  private loading: boolean = false;
  private title: string = '新增游戏';
  private tableData: iGameModel[] = [];
  mainImgUpload: iUploadeImagesList[] = [];
  gameMediaUpload: iUploadeImagesList[] = [];
  private model: iGameModel = {
    id: 0,
    name: '',
    category_id: -1,
    category_name: '',
    account_num: 0,
    remark: '',
    gid: '',
    act_free: 0,
    path: '',
    file_id: -1,
    main_img: '',
    game_media: [],
    account_mode: 2,
    steam_gid: '',
    archive_path: '',
    process_name: '',
    process_watch_min: 3,
    conn_tips: '',
    times_limit: 0,
  };
  private query: iSelectGame = {
    name: '',
    category_type: 1,
    ygx_game_id: undefined,
    isb: 0,
    act_free: -1,
  };
  private categoryTypeList = [
    { value: -1, label: '请选择创建类型' },
    { value: 2, label: '自动创建' },
    { value: 1, label: '手动创建' },
  ];
  private searchTypeList = [
    { value: 0, label: '选择搜索类型' },
    { value: 1, label: '黑名单' },
    { value: 2, label: '白名单' },
  ];

  private actFreeTypeList = [
    { value: -1, label: '请选择免账号状态' },
    { value: 1, label: '免账号' },
    { value: 0, label: '不免账号' },
  ];

  search() {
    this.page_query.page = 1;
    this.getSearchList();
  }
  clear() {
    this.model = JSON.parse(JSON.stringify(defaultModal));
    this.mainImgUpload = [];
    this.gameMediaUpload = [];
  }
  close() {
    this.visibleDialog = false;
  }
  /* 添加游戏 */
  addGame() {
    console.log(this.model);

    this.clear();
    this.title = '新增游戏';
    this.visibleDialog = true;
  }
  /* 修改游戏 */
  editRow(row: any) {
    this.clear();
    console.log(row, 'row');

    this.model = row;
    this.setUpload();
    this.title = '编辑游戏';
    this.visibleDialog = true;
  }
  /* 是否面賬號 */
  async updataAccount(row: any) {
    //  console.log(row);
    const res: any = await UpdateGame(row);
    if (res && res.code == 0) {
      toast('修改成功');
    }
  }
  /* 删除游戏 */
  removeRow(row: any) {
    this.$msgbox({
      title: '提示',
      message: '确认删除该游戏吗？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          try {
            let res: any = await delGame(row.id);
            if (res && res.code == 0) {
              toast('操作成功!');
              this.getSearchList();
            } else {
              toast(res.msg, 'error');
            }
            done();
            instance.confirmButtonLoading = false;
          } catch (error) {
            if (error && error.code == 1) {
              instance.confirmButtonText = '确定';
              instance.confirmButtonLoading = false;
            }
          }
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch(() => {
        // console.log(err);
      });
  }

  //属性缓存
  refreshCache() {
    this.$msgbox({
      title: '提示',
      message: '此按钮仅用于搜索缓存刷新，新增游戏和游戏相关设置无需刷新此按钮。是否确认刷新？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          try {
            let res: any = await goRefreshCache();
            if (res && res.code == 0) {
              toast('操作成功!');
            } else {
              toast(res.msg, 'error');
            }
            done();
            instance.confirmButtonLoading = false;
          } catch (error) {
            if (error && error.code == 1) {
              instance.confirmButtonText = '确定';
              instance.confirmButtonLoading = false;
            }
          }
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
        }
      },
    })
      .then(() => {})
      .catch(() => {
        // console.log(err);
      });
  }
  async getSearchList() {
    try {
      this.loading = true;
      const res = await getGameManage({ ...this.page_query, ...this.query });
      // console.log('res', res);
      this.tableData = res.data.list;
      this.total = res.data.total;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  mounted() {
    this.pageFn = this.getSearchList;
    this.getSearchList();
  }
  setUpload() {
    /* 非新增赋值 */
    // console.log(this.model);

    if (this.model.id && this.model.id > 0) {
      this.mainImgUpload = [
        {
          url: this.model.main_img,
        },
      ];
      this.gameMediaUpload = this.model.game_media == null ? [] : this.model.game_media;

      //   this.gameMediaUpload = JSON.parse(JSON.stringify(this.model.game_media));
    }
  }
}
